export enum GenderEnum {
  MASCULIN = 1,
  FEMININ = 2,
  BISEXUAL = 3,
  NECUNOSCUT = 4,
}
